import './components/popup';
import './common';
import './components/carousels';
import {make_fixed, viewport} from "./functions";

jQuery(function($) {
    function sticky_announcement () {
        if($('#announcement').length) {
            make_fixed($('#announcement'));
        }
    }

    sticky_announcement();

    $(window).on('load resize scroll', function () {
        sticky_announcement();
    });
});

